import React, { Component } from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux';
import _ from 'lodash';
import { motion, AnimateSharedLayout, AnimatePresence } from "framer-motion";

import { Button, RichText } from 'components'
import { FaTimes } from 'react-icons/fa'

import * as actionCreators from 'store/actions'
import classes from './NotesModule.module.css'

class NotesModule extends Component {
    constructor(props){
        super(props);
        this.buttonStyle = {
            backgroundColor: 'var(--secondary-color)',
            color: 'var(--text-color)',
            margin: 0,
            padding: '0.5rem'
        }
    }

    notesHandler = (data, plainText) => {
        if(this.props.type === 'Pages'){
            let updatedPage = {...this.props.data['pages'][this.props.id]}
            const currentData = updatedPage['notes']
            if(!_.isEqual(currentData, data)){
                updatedPage['notes'] = data
                this.props.updatePage(updatedPage, this.props.data, this.props.uid)
            }

        }
    }

    getNotes = () => {
        let notes = ''
        if(this.props.type === 'Pages'){
            const page = this.props.data['pages'][this.props.id]
            notes = page && page['notes']
        }
        return notes
    }

    render() {
        const notes = this.getNotes()        
        return(
            <div className={classes.NotesModule}>
                {/* <div className={classes.Header}>
                    <Button icon={<FaTimes/>} styles={this.buttonStyle} onSelect={() => this.props.setAccess(false, this.props.access, {})}/>
                </div> */}
                <RichText value={notes}
                    onSubmit={this.notesHandler}
                    placeholder='Brainstorm what to do' 
                    edit editable showInfo disableClose disableAutoFocus controls 
                    styles={{
                        primaryColor: 'var(--secondary-color)',
                        secondaryColor: 'var(--primary-color)',
                        height: '100%',
                        margin: 0,
                        padding: 0,
                        maxHeight: 'calc(100vh - 8rem)'
                    }}/>
            </div>            
        )
    }
}

const mapStateToProps = state => {
    return {
        uid: state.auth.uid,
        user: state.auth.user,
        data: state.db.present.data && state.db.present.data.toJS(),
        activePageID: state.auth.activePageID,

        window: state.content.window,
        body: state.content.body,

        showAccess: state.content.showAccess,
        access: state.content.access,
        accessProps: state.content.accessProps,
    }
};

const mapDispatchToProps = dispatch => {
    return {
        setModal: (element, id) => dispatch(actionCreators.setModal(element, id)),
        setAccess: (showAccess, module, accessProps) => dispatch(actionCreators.setAccess(showAccess, module, accessProps)),
        updatePage: (page, data, userId) => dispatch(actionCreators.updatePage(page, data, userId))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(NotesModule);